// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 966 ? "dashboard" : chunkId) + "." + {"140":"8a1e3269","209":"8a1e3269","301":"5c2a7dfe","470":"306a2acd","481":"5a2f24e6","750":"01c7701d","811":"1a54b611","966":"533a7a21"}[chunkId] + ".css";
};